import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ShieldCheck, ArrowLeft, Lock, BookOpen } from 'lucide-react';
import TamsPanel from '../training/TamsPanel';

const ADMIN_ROLES = new Set(['main_hub', 'department_admin', 'training_director', 'super_admin']);

const TamsManagePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = ADMIN_ROLES.has(user?.role);

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-[#0A0F1A] text-white flex items-center justify-center px-4" data-testid="tams-manage-denied">
        <div className="max-w-md w-full bg-[#131A2A] border border-rose-500/40 rounded-lg p-6 text-center">
          <Lock className="w-10 h-10 mx-auto text-rose-400" />
          <h2 className="mt-3 text-xl font-bold text-white">Access Restricted</h2>
          <p className="text-sm text-slate-300 mt-2">
            Training Access Management (TAMS) is restricted to Chief, Asst Chief, Training Director and Company Admin roles.
          </p>
          <button
            onClick={() => navigate('/nexus-new-hire')}
            className="mt-5 inline-flex items-center gap-1.5 text-amber-300 hover:text-amber-200 text-sm font-mono uppercase tracking-wider"
            data-testid="tams-manage-back"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Recruitment
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0F1A] text-white" data-testid="tams-manage-page">
      <div className="border-b border-[#1E293B] bg-gradient-to-r from-[#0F1B33] via-[#0A0F1A] to-[#0A0F1A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-11 h-11 rounded-md bg-amber-500/10 border border-amber-400/40 flex items-center justify-center flex-shrink-0">
              <ShieldCheck className="w-5 h-5 text-amber-300" />
            </div>
            <div className="min-w-0">
              <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-amber-300">Admin · Recruitment Command</p>
              <h1 className="text-2xl sm:text-3xl font-extrabold text-white mt-0.5 truncate">TAMS — Training Access Management</h1>
              <p className="text-xs text-slate-400 font-mono mt-0.5">Grant, revoke and audit training-center privileges for every member.</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate('/admin/course-builder')}
              className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-slate-900 bg-amber-400 hover:bg-amber-300 rounded px-3 py-2 font-semibold"
              data-testid="tams-manage-course-builder-btn"
            >
              <BookOpen className="w-4 h-4" /> Course Builder
            </button>
            <button
              onClick={() => navigate('/admin/certifications')}
              className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-amber-300 hover:text-amber-200 border border-amber-500/50 hover:border-amber-400 rounded px-3 py-2"
              data-testid="tams-manage-certs-btn"
            >
              <ShieldCheck className="w-4 h-4" /> Certificate Admin
            </button>
            <button
              onClick={() => navigate('/nexus-new-hire')}
              className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-slate-300 hover:text-amber-300 border border-slate-700 hover:border-amber-500/50 rounded px-3 py-2"
              data-testid="tams-manage-back-recruitment"
            >
              <ArrowLeft className="w-4 h-4" /> Back to Recruitment
            </button>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <TamsPanel />
      </div>
    </div>
  );
};

export default TamsManagePage;
